import React, {useEffect, useState} from 'react'
import TitreRapport from './titre_rapport.js'
import GraphAleasRapport from './graphAleas_Rapport.js'
import GraphAleasNBjoursRapport from './graphAleasNbjours_Rapport.js'
import GraphAleasNBjoursRapport2 from './graphAleasNbjours_Rapport2.js'
import apiLink from '../../config.js'
import FooterPDF from './footer.js'

function PageAleasPDF2({idExploit}) {
  const [ExploitMixte, setExploitMixte] = useState(false)
  const [ExploitViti, setExploitViti] = useState(false)
  const [ExploitGC,setExploitGC] = useState(true)

  const [dataMoy_EE_2D, setDataMoy_EE_2D] =  React.useState()
  const [dataMoy_EE_4D, setDataMoy_EE_4D] =  React.useState()
  const [dataMin_EE_2D, setDataMin_EE_2D] =  React.useState()
  const [dataMin_EE_4D, setDataMin_EE_4D] =  React.useState()
  const [dataMax_EE_2D, setDataMax_EE_2D] =  React.useState()
  const [dataMax_EE_4D, setDataMax_EE_4D] =  React.useState()
  const [dataQ1_EE_2D, setDataQ1_EE_2D] =  React.useState()
  const [dataQ1_EE_4D, setDataQ1_EE_4D] =  React.useState()
  const [dataQ3_EE_2D, setDataQ3_EE_2D] =  React.useState()
  const [dataQ3_EE_4D, setDataQ3_EE_4D] =  React.useState()
  const [dataNbjours_EE_2D, setdataNbjours_EE_2D] = React.useState()
  const [dataNbjours_EE_4D, setdataNbjours_EE_4D] = React.useState()
  const [dataNbjours_EE_Max_2D, setNBJ_EE_MAX_2D] = React.useState()
  const [dataNbjours_EE_Max_4D, setNBJ_EE_MAX_4D] = React.useState()
  const [dataNbjours_EE_Min_2D, setNBJ_EE_MIN_2D] = React.useState()
  const [dataNbjours_EE_Min_4D, setNBJ_EE_MIN_4D] = React.useState()


  function fetchData() {
    fetch(apiLink + 'page/production-rapport/' + idExploit)
    .then( (response) => {
    return response.json()
    })
    .then(response =>{
    let data = response
    for (var cle in data) {
        if (cle.includes("Vignes")) {
            setExploitMixte(true)
            setExploitGC(false)
            setExploitViti(false);
            break;
        }
    }
    let allKeysContainVignes = Object.keys(data).every(cle => cle.includes("Vignes"));
    if (allKeysContainVignes) {
        setExploitViti(true);
        setExploitMixte(false)
        setExploitGC(false)
    } else {
        setExploitViti(false);
    }
    })

    fetch('https://api2050.diagorisk.com/pageAleas/?idExploitation=' + idExploit + '&idProduction=none')
      .then((response) => response.json())
      .then((response) => {
        if ('error' in response) {
          // Si la réponse contient une erreur, relancer la requête après 60 secondes
          setTimeout(fetchData, 60000);
        } else {
          setDataMoy_EE_2D(response.dataMoy_EE_2D)
          setDataMoy_EE_2D(prev => {
            return prev;
          })
          setDataMoy_EE_4D(response.dataMoy_EE_4D)
          setDataMoy_EE_4D(prev => {
            return prev;
          })
          setDataMin_EE_2D(response.dataMin_EE_2D)
          setDataMin_EE_2D(prev => {
            return prev;
          })
          setDataMin_EE_4D(response.dataMin_EE_4D)
          setDataMin_EE_4D(prev => {
            return prev;
          })
          setDataMax_EE_2D(response.dataMax_EE_2D)
          setDataMax_EE_2D(prev => {
            return prev;
          })
          setDataMax_EE_4D(response.dataMax_EE_4D)
          setDataMax_EE_4D(prev => {
            return prev;
          })
          setDataQ1_EE_2D(response.dataQ1_EE_2D)
          setDataQ1_EE_2D(prev => {
            return prev;
          })
          setDataQ1_EE_4D(response.dataQ1_EE_4D)
          setDataQ1_EE_4D(prev => {
            return prev;
          })
          setDataQ3_EE_2D(response.dataQ3_EE_2D)
          setDataQ3_EE_2D(prev => {
            return prev;
          })
          setDataQ3_EE_4D(response.dataQ3_EE_4D)
          setDataQ3_EE_4D(prev => {
            return prev;
          })
          setdataNbjours_EE_2D(response.dataNbjours_EE_2D)
          setdataNbjours_EE_2D(prev => {
            return prev;
          })
          setdataNbjours_EE_4D(response.dataNbjours_EE_4D)
          setdataNbjours_EE_4D(prev => {
            return prev;
          })
          setNBJ_EE_MAX_2D(response.dataNbjoursMax_EE_2D)
          setNBJ_EE_MAX_2D(prev => {
            return prev;
          })
          setNBJ_EE_MAX_4D(response.dataNbjoursMax_EE_4D)
          setNBJ_EE_MAX_4D(prev => {
            return prev;
          })
          setNBJ_EE_MIN_2D(response.dataNbjoursMin_EE_2D)
          setNBJ_EE_MIN_2D(prev => {
            return prev;
          })
          setNBJ_EE_MIN_4D(response.dataNbjoursMin_EE_4D)
          setNBJ_EE_MIN_4D(prev => {
            return prev;
          })
        }
      })
      .catch((error) => {
        // Gérer les erreurs de la requête
        console.error('Erreur lors de la requête API :', error);
      });
  }
  useEffect ( () => {
    fetchData()
  }, [idExploit])
  
  return (
    <div className='containerPrint'>
      <TitreRapport Titre={"Impact de l'Excès d'eau"} Sous_Titre={"Sur toute l'exploitation"} Page={ExploitViti ? '0' : '6'}/>
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Niveau des risques de 2020 à 2050 </div>
      <div className='row' style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_EE_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_EE_2D} myDataMax4D={dataMax_EE_4D} aleas={'EE'} print={true} dataType={"Val"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_EE_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_EE_2D} myDataMoy4D={dataMoy_EE_4D}  aleas={'EE'} print={true} dataType={"Val"} type={'Moy'}/> :""}
        </div>
      </div>
      
      <div className='titreMoins row' style={{marginBottom:'20px', marginTop:'40px'}}> Evolution entre 2020 et 2050</div>
      <div className='row'  style={{width:'100%'}}>
        <div style={{width:'50%'}}>
          {dataMax_EE_2D !== undefined ?<GraphAleasRapport myDataMax2D={dataMax_EE_2D} myDataMax4D={dataMax_EE_4D} aleas={'EE'} print={true} dataType={"Diff"} type={'Max'}/> :""}
        </div>
        <div style={{width:'50%'}}>
          {dataMoy_EE_2D !== undefined ?<GraphAleasRapport myDataMoy2D={dataMoy_EE_2D} myDataMoy4D={dataMoy_EE_4D}  aleas={'EE'} print={true} dataType={"Diff"} type={'Moy'}/> :""}
        </div>
      </div>
      <FooterPDF idExploit={idExploit} top={'-20px'} />
    </div>
  )
}

export default PageAleasPDF2